import { InputAdornment } from "@mui/material";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { StyledTextField } from "../../utils/formStyles";
import { styled } from "@mui/material/styles";

interface Props {
  label: string;
  value: string;
  setValue: (value: string) => void;
  fullWidth?: boolean;
  placeholder?: string;
}

const StyledSearchIcon = styled(SearchIcon)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  padding: theme.spacing(0.5),
  color: "white",
  marginRight: theme.spacing(0.5),
  borderRadius: theme.spacing(1.25),
  fontSize: "1.2rem",
  transition: "all 0.3s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    transform: "scale(1.1)",
  },
}));

export const SearchInput = ({
  label,
  value,
  setValue,
  fullWidth = false,
  placeholder,
}: Props) => {
  return (
    <StyledTextField
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <StyledSearchIcon />
          </InputAdornment>
        ),
      }}
      type="text"
      label={label}
      placeholder={placeholder}
      variant="outlined"
      fullWidth={fullWidth}
      sx={{
        marginTop: 1,
        "& .MuiOutlinedInput-root": {
          paddingLeft: 1,
        },
      }}
    />
  );
};
